<template>
  <div>
    <div v-for="day in days" :key="day" class="ml-4">
      <label class="w-1/2 my-auto pt-3 font-bold"
        :id="dayVariantAddressId(direction, day)">
        {{ day }} (Optional Day-Variant)
      </label>
      <div class="border-grey-100 rounded-md border-2 pt-2 pb-3 px-3">
        <div class="block flex flex-row gap-7">
          <div class="block w-full grid grid-cols-2 gap-7 -mb-4 ">
            <div class="block w-full flex flew-row gap-7 justify-between">
              <label class="text-left text-nowrap align-middle ">
                {{ direction === 'in' ? 'Start Time:' : 'End Time:' }}
              </label>
              <TimeField class="w-2/3 self-center"
                :defaultValue="getDefaultTimeFromDay(filteredDefaultValue, day, 'programTime')"
                v-model="formValues.find((el) => el.day === day).programTime"
                @input="direction === 'in' ? subtractArrivalTime(-10, day) : subtractDepartureTime(10, day)">
              </TimeField>
            </div>
            <div class="block w-full flex flex-row gap-7 justify-between">
              <label class="text-left text-nowrap align-middle">
                {{ direction === 'in' ? 'Intended Arrival Time:' : 'Intended Departure Time:' }}
              </label>
              <TimeField class="w-2/3 self-center"
                :defaultValue="getDefaultTimeFromDay(filteredDefaultValue, day, 'transportTime')"
                v-model="formValues.find((el) => el.day === day).transportTime">
              </TimeField>
            </div>
          </div>
        </div>
        <StudentAddress
          :defaultValue="getDefaultValueFromDay(filteredDefaultValue, day, 'address')"
          :required="false"
          @input="checkAddress(formValues.find((el) => el.day === day))"
          v-model="formValues.find((el) => el.day === day).address"
          :showClearStateField="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import StudentAddress from './StudentAddress.vue'
import TimeField from './formComponents/TimeField.vue'

import time from '../services/utils/time.js'

const WEEKDAY_ORDER_MAP = {
  'Sunday': 0,
  'Monday': 1,
  'Tuesday': 2,
  'Wednesday': 3,
  'Thursday': 4,
  'Friday': 5,
  'Saturday': 6,
}

export default {
  props: {
    defaultValue: [],
    daysList: [],
    direction: String,
  },
  components: {
    StudentAddress,
    TimeField
  },
  data() {
    return {
      skipTimeAdjustments: {},
      formValues: [],
    }
  },
  methods: {
    checkAddress(day) {
      if (day.address != this.defaultAddress) {
        if (
          day.address.street == undefined &&
          day.address.apartment == undefined &&
          day.address.city == undefined &&
          day.address.state == undefined &&
          day.address.zip_code == undefined
        ) {
          day.diffAddress = false
        }
        day.diffAddress = true
      }
      else {
        day.diffAddress = false
      }
    },
    minutesOff(initTime, minutes) {
      var date = new Date()
      var HH = initTime.substring(0, 2)
      var MM = Number(initTime.substring(3, 5)) + minutes
      date.setHours(HH, MM)
      var newHH = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var newMM = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      return newHH + ':' + newMM
    },
    subtractArrivalTime(minutes, day) {
      if (this.skipTimeAdjustments[day]) {
        this.skipTimeAdjustments[day] = false
        return
      }
      let temp = this.formValues.find((el) => el.day === day)
      if (temp) {
        if (!temp.programTime) {
          return
        }
        temp.transportTime = this.minutesOff(temp.programTime, minutes)
      } else {
        temp.transportTime = ''
      }
    },
    subtractDepartureTime(minutes, day) {
      if (this.skipTimeAdjustments[day]) {
        this.skipTimeAdjustments[day] = false
        return
      }
      let temp = this.formValues.find((el) => el.day === day)
      if (temp) {
        if (!temp.programTime) {
          return
        }
        temp.transportTime = this.minutesOff(temp.programTime, minutes)
      } else {
        temp.transportTime = ''
      }
    },
    getDefaultValueFromDay(array, day, fieldKey) {
      this.skipTimeAdjustments[day] = true
      let item = array.find(el => el.day === day)
      if (item === undefined) {
        return undefined
      }
      return item[fieldKey]
    },
    getDefaultTimeFromDay(array, day, fieldKey) {
      return time.toInputField(this.getDefaultValueFromDay(array, day, fieldKey))
    },
    dayVariantAddressId(direction, day) {
      if (direction === 'in') {
        return `Inbound Day-${day}`
      }
      else if (direction === 'out') {
        return `Outbound Day-${day}`
      }
    },
    updateValue() {
      this.$emit('input', this.formValues)
    },
  },
  computed: {
    days() {
      if (this.daysList.includes('Other')) {
        return this.daysList.filter((val) => val !== 'Other')
      }
      return this.daysList.toSorted((a, b) => WEEKDAY_ORDER_MAP[a] - WEEKDAY_ORDER_MAP[b])
    },
    filteredDefaultValue() {
      if (this.defaultValue == undefined) {
        return []
      }
      return this.defaultValue
    },
  },
  // mounted() {
  //   // do nothing
  // },
  beforeMount() {
    this.days.forEach((el) => {
      this.formValues.push({
        'day': el,
        'programTime': null,
        'transportTime': null,
        'diffAddress': false,
        'address': null,
      })
    })
  },
  watch: {
    formValues() {
      this.updateValue()
    },
    days(val) {
      val.forEach((el) => {
        if (!this.formValues.find((item) => item.day === el)) {
          this.formValues.push({
            'day': el,
            'programTime': null,
            'transportTime': null,
            'diffAddress': false,
            'address': null,
          })
        }
      })
    },
  }
}
</script>
